import mainApi from './mainApi';

export const loginRequest = async (username, password) => {

  try {
    const response = await mainApi.post(`/authenticate`, { username, password });
    return response.data;
  } catch (error) {
    throw error;
  }
};